// utils/employeeView.js
// ─────────────────────────────────────────────────────────────────────────
// "Employee view" = the personal (My …) screens. It uses the SAME rule the
// backend uses for record scope (utils/recordScope.canManageAllRecords):
// Super Admin, Branch Admin and Admin manage everyone's records; every other
// role works on their own records. Permission keys are never changed — this
// only decides which screen/label to show for a page the user may already open.
// ─────────────────────────────────────────────────────────────────────────
import { usePermissions } from "../context/PermissionContext";

export const RECORD_MANAGER_ROLES = ["Super Admin", "Branch Admin", "Admin"];

// Sidebar labels shown in the employee view (keys = existing labels).
export const MY_LABELS = {
  Attendance: "My Attendance",
  Attendances: "My Attendance",
  Leave: "My Leave",
  "Leave Management": "My Leave",
  "Task Management": "My Tasks",
  Projects: "My Projects",
  "Enquiry List": "My Leads",
  "Follow Ups": "My Follow Ups",
};

export const isEmployeeRole = (role) =>
  !!role && !RECORD_MANAGER_ROLES.includes(String(role).trim());

export const useEmployeeView = () => {
  const { userRole, loading } = usePermissions();
  const isEmployeeView = !loading && isEmployeeRole(userRole);
  const myLabel = (label) => (isEmployeeView ? MY_LABELS[label] || label : label);
  return { isEmployeeView, loading, myLabel };
};
